import HelpOutlineOutlined from "@mui/icons-material/HelpOutlineOutlined";
import { Tooltip } from "@mui/material";
import { ReactNode } from "react";
import { FieldValues } from "react-hook-form";

type InputTooltipProps<T extends FieldValues> = {
  title: ReactNode;
  placement?:
    | "bottom"
    | "bottom-end"
    | "bottom-start"
    | "left"
    | "left-end"
    | "left-start"
    | "right"
    | "right-end"
    | "right-start"
    | "top"
    | "top-end"
    | "top-start";
};

export const InputTooltip = <T extends FieldValues>({
  title,
  placement = "bottom",
}: InputTooltipProps<T>) => {
  return (
    <Tooltip
      title={title}
      className="input-tooltip"
      arrow
      leaveDelay={250}
      style={{ marginLeft: "4px", padding: "0" }}
      placement={placement}
      slotProps={{
        tooltip: {
          sx: (theme) => ({
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            fontWeight: theme.typography.fontWeightRegular,
            padding: theme.spacing(1),
            boxShadow: theme.shadows[5],
            whiteSpace: "pre-wrap",
          }),
        },
        arrow: {
          sx: (theme) => ({
            color: theme.palette.background.paper,
          }),
        },
      }}
    >
      <HelpOutlineOutlined fontSize="small" />
    </Tooltip>
  );
};
